<div class="flex flex-col justify-content mt-[80px]">
    <div class="font-outfit font-semibold text-3xl text-center p-2">
        why your business needs a <span class="gradient-text">mobile edge</span> ?
    </div>
    <app-marketing-card-container [cardInfo]="cardInfo"></app-marketing-card-container>
</div>